import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
export const ContentBody = () => {
    const { t } = useI18n();
    return (_jsxs(Box, { padding: "spacing.4", children: [_jsx(Box, { typography: "typography.body.16.bold", marginBottom: "spacing.16", children: t("advertising.slot.dsa.title") }), _jsx(Box, { typography: "typography.body.14.regular", children: t("advertising.slot.dsa.description") })] }));
};
